import React, { useMemo } from "react";
import { useWatch } from "react-hook-form";

import useFormWatch from "@rf-hooks/useFormWatch";
import { CPropertyValidationDocumentKeys } from "@rf/property/module/components/property-form/util/schemas/validation-documents/validation-document.schema";
import { CPropertyForm, CPropertyFormKeys } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";

const useLoadField = () => {
  const { file_title_property, file_title_transfer_trustee } = useFormWatch([
    CPropertyValidationDocumentKeys.file_title_transfer_trustee,
    CPropertyFormKeys.file_title_property
  ]);

  const hasTitleProperty = useMemo(
    () => (CPropertyForm.file_title_property || []).length >= 1,
    [file_title_property]
  );
  const hasTitleTransfererToTrust = useMemo(
    () => (CPropertyForm.file_title_transfer_trustee || []).length >= 1,
    [file_title_transfer_trustee]
  );

  return {
    hasTitleTransfererToTrust,
    hasTitleProperty
  };
};

export default useLoadField;
